/**
 * 최초 앱이 로딩될 때 디바이스 크기에 따라 mobile 인지 아닌지 결정
 * 이후 창 크기 변경에 무관하게 처음 결정된 레이아웃을 따름
 */
export class Device {
    static readonly isMobile = window.innerWidth <= 768;
}